export const causeMarketingData = [
  {
    id: 1,
    name: 'Cleaning for a Reason',
    url: 'https://cleaningforareason.org/',
    image: 'https://res.cloudinary.com/twomaidsengi/image/upload/v1740686860/hubsite-reskin/CFR_Lavender-Tagline_side_11-2_tm.webp',
    description: "We donate our time and services to cancer patients and their families so they can focus on healing - not housework.",
  },
  {
    id: 2,
    name: 'The Finley Project',
    url: 'https://www.thefinleyproject.org/',
    image: 'https://res.cloudinary.com/twomaidsengi/image/upload/v1713540352/hubsite-reskin/TheFinleyProject.webp',
    description: 'We offer cleaning services to grieving mothers who have experienced the loss of an infant, supporting them as part of a 7-part holistic healing program.',
  },
  {
    id: 3,
    name: 'Alliance for HOPE',
    url: 'https://www.allianceforhope.com/',
    image: 'https://res.cloudinary.com/twomaidsengi/image/upload/v1682368766/hubsite-reskin/alliance_for_hope.webp',
    description: "We support survivors of domestic violence, sexual assault, and child abuse through this nationally recognized, evidence-based program.",
  },
  {
    id: 4,
    name: 'Brady Wynn Foundation',
    url: 'https://bradywynnfoundation.org/',
    image: 'https://res.cloudinary.com/twomaidsengi/image/upload/v1740687120/hubsite-reskin/Brady_Wynn_Foundation_Logo_With_Writing_1.webp',
    description: "We help families of infants with life-threatening neurological conditions by easing the burden of keeping their homes clean during critical times."
  }
];